import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HostNavSync } from './components/HostNavSync';
import { DashboardPage } from './pages/DashboardPage';
import { PodcastsPage } from './pages/PodcastsPage';
import { PodcastDetailPage } from './pages/PodcastDetailPage';
import { EpisodeDetailPage } from './pages/EpisodeDetailPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { MediaLibraryPage } from './pages/MediaLibraryPage';
import { SponsorsPage } from './pages/SponsorsPage';
import { StudioPage } from './pages/StudioPage';
import { StudioRoomPage } from './pages/StudioRoomPage';
import { GuestJoinPage } from './pages/GuestJoinPage';
import { SettingsPage } from './pages/SettingsPage';
import { JobsPage } from './pages/JobsPage';

export function App() {
  return (
    <>
      <HostNavSync />
      <Routes>
        {/* Guests arrive from a link: no layout, no Rumio session. */}
        <Route path="join/:inviteToken" element={<GuestJoinPage />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<DashboardPage />} />
          {/* The host mount's default path is /dashboard. */}
          <Route path="dashboard" element={<Navigate to="/" replace />} />
          <Route path="podcasts" element={<PodcastsPage />} />
          <Route path="podcasts/:podcastId" element={<PodcastDetailPage />} />
          <Route path="podcasts/:podcastId/episodes/:episodeId" element={<EpisodeDetailPage />} />
          <Route path="media" element={<MediaLibraryPage />} />
          <Route path="sponsors" element={<SponsorsPage />} />
          <Route path="studio" element={<StudioPage />} />
          <Route path="studio/:roomId" element={<StudioRoomPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

function NotFound() {
  return (
    <div className="py-12 text-center">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="mt-2 text-muted">Check the URL or use the navigation to find your way.</p>
    </div>
  );
}
